import { getLocaleBasePath } from '@raisin/cp-utils';
export const getCockpitURL = (url, locale = '') => `${getLocaleBasePath(locale)}/investments/wealth-management/dashboard${url}`;
export const getSavingglobalUrl = (url, locale = '') => `${getLocaleBasePath(locale)}/savingglobal${url}`;
//# sourceMappingURL=utils.js.map